import { useState } from 'react';
import { Box, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import clsx from 'clsx';

import CategoryList from '../../components/CategoryList/CategoryList';

import CaseTypesEditSection from './CaseTypesEditSection';

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 0px 16px 0px',
    gap: '16px',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  sectionHeight: {
    height: '100%',
  },
  headline: {
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '23px',
    color: theme.palette.common.white,
  },
}));

const CaseTypesView = () => {
  const { classes } = useStyles();
  const firmId = localStorage.getItem('firmId');

  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  return (
    <Box className={classes.container}>
      <Box className={classes.section}>
        <Typography className={classes.headline}>{'Categories'}</Typography>
        <CategoryList
          selectedCategory={selectedCategory}
          handleSelect={(category) => setSelectedCategory(category)}
        />
      </Box>

      {firmId && selectedCategory && (
        <Box className={clsx(classes.section, classes.sectionHeight)}>
          <Typography className={classes.headline}>{'Case Types'}</Typography>
          <CaseTypesEditSection category={selectedCategory} firmId={firmId} />
        </Box>
      )}
    </Box>
  );
};

export default CaseTypesView;
